<template>
    <div class="backgroud-white cs-homwwork-infor">
        <el-row class="cs-homework-infor-header">
            <span class="cs-homework-title">作业完成信息</span>
        </el-row>
        <div>
            <ul>
                <li>
                    <el-row>
                        <el-col :span="18">作业完成率</el-col>
                        <el-col :span="6" :class="completeRateColor">
                            {{homeworkStatistic.CompleteRate}}%
                        </el-col>
                    </el-row>
                </li>
                <li>
                    <el-row>
                        <el-col :span="18">班级人数</el-col>
                        <el-col :span="6">
                            {{homeworkStatistic.TotalStudents}}
                        </el-col>
                    </el-row>
                </li>
                <li>
                    <el-row>
                        <el-col :span="18">按时完成</el-col>
                        <el-col :span="6">
                            {{homeworkStatistic.FinishedCount}}
                        </el-col>
                    </el-row>
                </li>
                <li>
                    <el-row>
                        <el-col :span="18">未完成</el-col>
                        <el-col :span="6">
                            {{homeworkStatistic.UnfinishedCount}}
                        </el-col>
                    </el-row>
                </li>
                <li>
                    <el-row>
                        <el-col :span="18">作业平均分</el-col>
                        <el-col :span="6" :class="averageScoreColor">
                            {{homeworkStatistic.AverageScore}}
                        </el-col>
                    </el-row>
                </li>
            </ul>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.cs-homwwork-infor {
    padding: 10px 30px;
    ul {
        margin: 0;
        padding: 0
    }
    ul>li {
        list-style-type: none;
        color: black;
        padding-top: 1rem;
    }
    .cs-homework-infor-header {
        margin-bottom: 1rem;
    }
    .cs-homework-infor-title {
        font-weight: bold;
        font-size: 20px;
        padding-right: 10px;
        text-align: right;
    }
}
</style>

<script>
import { getCourseHomeworkStatistic } from "../../service/homework.service";
export default {
    props: {
        data: {
           homeworkId: Number,
        },
    },
    data() {
        return {
            homeworkStatistic: {},
            averageScoreColor: '',
            completeRateColor: '',
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            getCourseHomeworkStatistic(this.data.homeworkId).then(result => {
                if (!!result && result.success) {
                    this.homeworkStatistic = result.data;
                    switch (this.homeworkStatistic.AverageScore) {
                        case '差':
                            this.averageScoreColor = "cs-score-poor";
                            break;
                        case '中':
                        case '良-':
                        case '良':
                            this.averageScoreColor = "cs-score-fair";
                            break;
                        case '优-':
                        case '优':
                            this.averageScoreColor = "cs-score-good";
                            break;
                        default:
                            this.averageScoreColor = "";
                    }
                    if (this.averageScoreColor !== "") {
                        if (this.homeworkStatistic.CompleteRate >= 70) {
                            this.completeRateColor = "cs-score-good";
                        } else if (this.homeworkStatistic.CompleteRate >= 50) {
                            this.completeRateColor = "cs-score-fair";
                        } else {
                            this.completeRateColor = "cs-score-poor"
                        }
                        this.homeworkStatistic.CompleteRate = this.homeworkStatistic.CompleteRate.toFixed(1);
                    }
                }
            });
        }
    },
    watch: {
        data: function() {
            this.init();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/homework/homeworkCompleteInfor.vue